import { defineComponent, ref, openBlock, createElementBlock, createElementVNode, mergeProps, createVNode, unref, Fragment, renderList, createBlock, createCommentVNode } from "vue";
import { IconCheckFill } from "@rei/cedar";
import UgcImage from "../UgcImage/UgcImage.mjs";
import UgcImageViewerProductTile from "./UgcImageViewerProductTile/UgcImageViewerProductTile.mjs";
const _hoisted_1 = {
  class: "ugc-image-viewer",
  tabindex: "-1"
};
const _hoisted_2 = {
  class: "ugc-image-viewer__image-frame"
};
const _hoisted_3 = {
  key: 0,
  class: "ugc-image-viewer__product-gallery"
};
const _hoisted_4 = {
  class: "ugc-image-viewer__product-gallery-scroller"
};
const _hoisted_5 = ["aria-current", "onClick"];
const _hoisted_6 = ["src", "alt"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UgcImageViewer",
  props: {
    id: {},
    title: {
      default: ""
    },
    imageSrc: {},
    likes: {
      default: 0
    },
    postedDate: {},
    products: {},
    selectedProduct: {},
    user: {}
  },
  emits: ["ugcImageViewerSelect", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const productInfo = ref();
    const emit = __emit;
    function handleGalleryClick(product, source) {
      var _a;
      (_a = productInfo.value) == null ? void 0 : _a.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      emit("ugcImageViewerSelect", product);
      emit("metricsClick", {
        linkName: source
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", mergeProps(_ctx.$attrs, {
        class: "ugc-image-viewer__content",
        tabindex: "-1"
      }), [createElementVNode("div", _hoisted_2, [createVNode(unref(UgcImage), {
        id: _ctx.id,
        class: "ugc-image-viewer__main-image",
        "image-src": _ctx.imageSrc,
        "is-focusable": true,
        layout: "vertical",
        "expandable-hotspot": true,
        likes: _ctx.likes,
        "posted-date": _ctx.postedDate,
        products: _ctx.products,
        title: _ctx.title,
        user: _ctx.user,
        "current-product-id": _ctx.selectedProduct.productId,
        "img-height": "1080",
        "img-width": "1080",
        "zoom-background": false,
        onUgcImageClick: _cache[0] || (_cache[0] = (data) => handleGalleryClick(data.product, "ugc_beacon")),
        onMetricsClick: _cache[1] || (_cache[1] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["id", "image-src", "likes", "posted-date", "products", "title", "user", "current-product-id"])]), createElementVNode("div", {
        ref_key: "productInfo",
        ref: productInfo,
        class: "ugc-image-viewer__products"
      }, [_cache[3] || (_cache[3] = createElementVNode("h2", {
        class: "ugc-image-viewer__heading"
      }, " In this photo ", -1)), createVNode(unref(UgcImageViewerProductTile), mergeProps(_ctx.selectedProduct, {
        class: "ugc-image-viewer__product-tile",
        onMetricsClick: _cache[2] || (_cache[2] = (data) => _ctx.$emit("metricsClick", data))
      }), null, 16), _cache[4] || (_cache[4] = createElementVNode("div", {
        class: "ugc-image-viewer__product-divider"
      }, null, -1)), _ctx.products.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_3, [createElementVNode("div", _hoisted_4, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.products, (product) => {
        return openBlock(), createElementBlock("button", {
          key: product.id,
          "aria-current": _ctx.selectedProduct.productId === product.metadata.productId,
          class: "ugc-image-viewer__product-gallery-image-container",
          onClick: ($event) => handleGalleryClick(product, "ugc_product gallery")
        }, [_ctx.selectedProduct.productId === product.metadata.productId ? (openBlock(), createBlock(unref(IconCheckFill), {
          key: 0,
          class: "ugc-image-viewer__selected"
        })) : createCommentVNode("", true), createElementVNode("img", {
          src: product.images[0].small,
          class: "ugc-image-viewer__product-gallery-images",
          alt: `select ${product.name}`
        }, null, 8, _hoisted_6)], 8, _hoisted_5);
      }), 128))])])) : createCommentVNode("", true)], 512)], 16)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=UgcImageViewer2.mjs.map
